module.exports = __webpack_public_path__ + "img/pl.58bd4f5b.png";